var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DELETE_LR_POST_REQUEST, DELETE_LR_POST_SUCCESS, DELETE_LR_POST_ERROR } from '../actions/deleteLongReadPost';
var initialState = {
    isFetching: false,
    isError: false,
    data: {}
};
export function deleteLongReadPostReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case DELETE_LR_POST_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case DELETE_LR_POST_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, data: action.payload.data });
        case DELETE_LR_POST_ERROR:
            return __assign(__assign({}, state), { isFetching: false, isError: true });
        default:
            return state;
    }
}
;
//# sourceMappingURL=deleteLongReadPost.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DELETE_LR_POST_REQUEST, DELETE_LR_POST_SUCCESS, DELETE_LR_POST_ERROR } from '../actions/deleteLongReadPost';
var initialState = {
    isFetching: false,
    isError: false,
    data: {}
};
export function deleteLongReadPostReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case DELETE_LR_POST_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case DELETE_LR_POST_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, data: action.payload.data });
        case DELETE_LR_POST_ERROR:
            return __assign(__assign({}, state), { isFetching: false, isError: true });
        default:
            return state;
    }
}
;
//# sourceMappingURL=deleteLongReadPost.js.map